import { render, staticRenderFns } from "./AddQuestions.vue?vue&type=template&id=ac274ad4&scoped=true"
import script from "./AddQuestions.vue?vue&type=script&lang=js"
export * from "./AddQuestions.vue?vue&type=script&lang=js"
import style0 from "./AddQuestions.vue?vue&type=style&index=0&id=ac274ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac274ad4",
  null
  
)

export default component.exports